import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as Account } from '../../../../../resources/images/header-icons/account.svg';
import { ReactComponent as BurgerMenu } from '../../../../../resources/images/svg/burgerMenu.svg';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import { useAuth } from '../../../../contexts/userContext/userContext';
import MainLogo from '../../../../../resources/images/gr-logo-white-bg.png';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { ReactComponent as Search } from '../../../../../resources/images/svg/search.svg';
import { ReactComponent as Calendar } from '../../../../../resources/images/svg/calendar.svg';

const headerIconWrapper = 'bg-white w-[42px] h-[42px] rounded-[28px] flex justify-center items-center';

function MobileHeader() {
  const { setShowAuthModal, setShowNavigationDrawer, setShowProfileDrawer } = useModal();
  const { user } = useAuth();
  const { currentLanguage, configInfo } = useTranslation();
  const location = useLocation();
  return (
    <div
      className="lg:hidden absolute container flex justify-between items-center gap-4 pt-4 mobile-padding"
      style={{
        zIndex: location.pathname.split('/')[2] ? 10 : 1,
      }}
    >
      <Link to={`/${currentLanguage}`}>

        {configInfo?.countryCode === 'GE'
          ? (
            <img width={90} height={42} src={MainLogo} alt="GR logo" />
          )
          : (
            <img
              src="/ticketLogos/mobileLogoArm.png"
              alt="Armenia Railway Logo"
              width={90}
              height={42}
            />
          )}
      </Link>
      <div className="flex gap-4">
        <Link
          to={`/${currentLanguage}`}
          className={`${headerIconWrapper} -rotate-45`}
        >
          <Search
            className="h-5 w-5"
          />
        </Link>
        <Link
          to={`/${currentLanguage}/schedule`}
          className={headerIconWrapper}
        >
          <Calendar
            className="h-5 w-5"
          />
        </Link>
        <div className={headerIconWrapper}>
          <Account
            onClick={() => (user?.name ? setShowProfileDrawer(true) : setShowAuthModal(true))}
            className="h-5 w-5"
          />
        </div>
        <div className={headerIconWrapper}>
          <BurgerMenu onClick={() => setShowNavigationDrawer(true)} />
        </div>
      </div>
    </div>
  );
}

export default MobileHeader;
